import { useLocation } from 'react-router';

const useHash = () => {
  const { hash } = useLocation();
  return hash;
};

export default useHash;
